<script>
import './style.scss';
import template from './template.html';
import axios from 'axios';
import {ChevronDownIcon, ChevronUpIcon, CloseIcon} from './../../icons';
import {mapMutations, mapState} from 'vuex';

export default {

  computed: {
    ...mapState('ReviewerImportFormStore', [
      'showImportForm',
    ])
  },
  methods: {
    ...mapMutations('ReviewerImportFormStore', [
      'toggleShowForm',
    ]),
    downloadImportTemplate () {
      // /reviewer/import-template-download
    },
    handleFileUpload () {

      this.file = this.$refs.file.files[0];

    },
    handleImport () {

      if (!this.file) {
        alert("Please select a file...");
        return;
      }

      // if (this.file.type !== "text/csv") {
      //
      //   alert("The uploaded file could not be properly imported. Please check the format of the file and try again.");
      //   return;
      // }

      let formData = new FormData();
      formData.append('file', this.file);

      var self = this;

      axios.post('/review/reviewer/import',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then(function (res) {

        if (!res.data.errors.length && !res.data.users.length) {
          alert('No data found in CSV upload. Please add reviewers to the CSV file.');
        }

        self.uploadErrors = res.data.errors;
        self.uploadedUsers = res.data.users;
      })
          .catch(function (error) {
            console.error(error);
            alert("The uploaded file could not be properly imported. Please check the format and content of the file and try again.");
          });

    },
    closeForm: function () {
      this.toggleShowForm(false);
      location.reload();
    }
  },

  template,
  data () {
    return {
      file: '',
      showInstructions: false,
      uploadErrors: [],
      uploadedUsers: [],
      accounts: [{
        'id': backend.user.usergroup.id,
        'name': backend.user.usergroup.company,
      }]
    };
  },

  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    CloseIcon,
  }
};
</script>
